<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
        
        <section id="pro" class="bg-scroll wide-60 content-section pro_part division">
            <div class="container">
                <div class="row d-flex align-items-center">


                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 " >
                        <div class="content-img">
                            <img class="img-fluid" src="@/assets/images/LDP-1350.webp" alt="content-image" />
                        </div>
                    </div>


                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                APAYM Pro, la solution pour accroître votre business.
                            </h2>
                            
                            <!-- Text -->	
                            <p class="" >
                                APAYM Pro est une solution de paiement spécialement conçue pour ACCEPTER, faciliter et accélérer
                                le paiement digital des commerces, petites et moyennes entreprises. Une application mobile qui vous
                                permet, en tant que marchand, de contrôler toutes vos transactions.
                            </p> 
                        
                            <!-- Title -->	
                            <h5 class="h5-md " >
                                Plus de problème de cash.
                            </h5>
                                            
                            <!-- Text -->	
                            <p class="" >
                                Parce que le temps c’est de l’argent, facilitez le paiement de vos clients en générant en une seconde,
                                un QR Code dynamique qu’ils pourront scanner avec leur smartphone et effectuer la transaction en toute sécurité en un clic.
                            </p>

                                            
                            <!-- Text -->	
                            <p class="">
                            <!-- Button -->						
                            <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange">Créer un compte Pro</a>                    
                            </p>
                        </div>
                    </div>
                    <!-- END CONTENT TEXT -->


                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>

         <!-- Lien de paiement -->
        <section id="content-8" class="wide-60  reduc_mob  content-section division sct_tuto  grey_bck_section">
            <div class="container">	


                <!-- SECTION TITLE 	-->	
                <div class="row">	
                    <div class="col-lg-10 offset-lg-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">Le lien de paiement <br>APAYM Pay</h2>

                        <!-- Text -->
                        <p></p>
                                
                    </div>	
                </div> 	 <!-- END SECTION TITLE -->	


                <div class="row">
                    <div class="col-md-12">
                    


                        <!-- TABS CONTENT -->
                        <div class="tab-content" id="pills-tabContent">


                            <!-- TAB-1 CONTENT -->
                            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab1-list">
                                <div class="row d-flex align-items-center">


                                    <!-- TAB-1 TEXT -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid ltp1" src="@/assets/images/lien-paiement.png" width="500" alt="content-image">
                                        </div>

                                        <div class="content-txt ind-45"> 
                                            
                                            <p>Le lien de paiement est un lien URL sécurisé à usage unique dont dispose un marchand APAYM PRO.</p>
                                            <p><a href="https://pay.apaym.com/weblogyoffshore" target="_blank" class="link">https://pay.apaym.com/weblogyoffshore</a> </p>

                                            <p>Grâce à ce lien, encaisser instantanément vos clients à distance et partout dans le monde entier.</p>

                                            <p>Le marchand APAYM PRO peut partager son lien de paiement à tous les clients par différents canaux de communication :</p>

                    
                                                
                                            <!-- Text -->	
                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Par SMS</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Par WhatsApp</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Par adresse email</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Sur les réseaux sociaux</p>							
                                            </div>

                                            <!-- Text -->	
                                            <p class="">
                                            <!-- Button -->						
                                            <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange">Créer un compte Pro</a>                    
                                            </p>

                                            </div>	
                                            

                                    </div>	<!-- END TAB-1 TEXT -->


                                    <!-- TAB-1 IMAGE -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid ltp2" src="@/assets/images/lien-paiement.png" width="500" alt="content-image">
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>	<!-- END TAB-1 CONTENT -->

                        </div>	<!-- END TABS CONTENT -->


                    </div>	
                </div>     <!-- End row -->	
            </div>     <!-- End container -->	
        </section>	
        <!-- Fin Lien de paiement -->

        <!-- La carte APAYM PRO -->
        <section id="pro" class="bg-scroll wide-60 content-section pro_part division">
            <div class="container">
                <div class="row d-flex align-items-center">


                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 " >
                        <div class="content-img">
                            <img class="img-fluid" src="@/assets/images/carte-apaym-pro.png" alt="content-image" />
                        </div>
                    </div>


                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">


                            <!-- Title -->
                            <h2 class="h2-xs " >
                                La carte APAYM Pro
                            </h2>

                            <!-- Text -->
                            <p class="" >
                                APAYM Pro est la carte physique prépayée Visa spécialement conçue pour les commerçants.
                                Couplée au lien de paiement, elle permet d’encaisser vos clients de façon instantanée.
                            </p>

                            <!-- Title -->
                            <h5 class="h5-md " >
                                Economie garantie
                            </h5>

                            <!-- Text -->
                            <p class="" >
                                Oubliez les frais cachés qui faussent le budget et maîtrisez votre budget
                            </p>

                            <!-- Text -->
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                <p>Frais de gestion mensuels : <strong> 0 F </strong> </p>
                            </div>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                <p>Retraits gratuits dans les guichets VISA en Côte d'Ivoire et dans la zone GIM UEMOA :<strong> 0 F </strong> </p>
                            </div>

<!--                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">-->
<!--                                <div class="box-list-icon"><svg class="svg-inline&#45;&#45;fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg>&lt;!&ndash; <i class="fas fa-genderless"></i> &ndash;&gt;</div>-->
<!--                                <p>Frais de retrait au TPE à l’international : <strong> 1,5 %  </strong> </p>-->
<!--                            </div>-->

                            <!-- Title -->
                            <h5 class="h5-md " >
                                Faites confiance à APAYM Pro pour vous soutenir ou que vous soyez
                            </h5>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                <p> Sécurité renforcée grâce à la 3D Secure </p>
                            </div>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                <p> Support client Whatsapp disponible 24 h/7 jours </p>
                            </div>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                <p> Coût de la carte : 5000 F valable 3 ans </p>
                            </div>




                            <!-- Text -->
                            <p class="">
                                <!-- Button -->
                                <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange">Créer un compte Pro</a>
                            </p>
                        </div>
                    </div>
                    <!-- END CONTENT TEXT -->


                </div>	   <!-- End row -->
            </div>	   <!-- End container -->
        </section>
        <!-- Fin carte APAYM PRO -->

        <!-- QR Code APAYM -->
        <section id="content-8" class="wide-60 content-section division sct_tuto  grey_bck_section">
            <div class="container">


                <!-- SECTION TITLE 	-->
                <div class="row">
                    <div class="col-lg-10 offset-lg-1 section-title">

                        <!-- Title 	-->
                        <h2 class="h2-lg">QR Code APAYM</h2>

                        <!-- Text -->
                        <p></p>

                    </div>
                </div> 	 <!-- END SECTION TITLE -->


                <div class="row">
                    <div class="col-md-12">



                        <!-- TABS CONTENT -->
                        <div class="tab-content" id="pills-tabContent">


                            <!-- TAB-1 CONTENT -->
                            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab1-list">
                                <div class="row d-flex align-items-center">


                                    <!-- TAB-1 TEXT -->
                                    <div class="col-md-6">
                                        <div class="content-txt ind-45">

                                            <p> Le QR Code APAYM est un QR code sécurisé à usage unique qui accepte à la fois les paiements par carte bancaire et mobile money.</p>

                                            <p>Le client, lors de son passage en caisse, peut désormais scanner le QR code du marchand APAYM PRO depuis l’appareil photo de son smartphone et choisir le moyen  de paiement qui lui sied ( mobile money ou cartes bancaires).</p>

                                            <p> Le marchand APAYM PRO peut utiliser un seul QR code pour tous ses services et son QR code n'expire jamais.</p>

                                            <p> Une fois configuré, le marchand peut l’utiliser aussi longtemps qu’il le souhaite.</p>
                                            <p><strong>Exemple vidéo :</strong> <a href="https://youtu.be/EpAlt2_Eeh8" target="_blank" class="link">https://youtu.be/EpAlt2_Eeh8</a></p>


                                            <!-- Text -->
                                            <p class="">
                                                <!-- Button -->
                                                <a href="#contacts-2" class="btn btn-lightorange">Créer un compte Pro</a>
                                            </p>

                                        </div>


                                    </div>	<!-- END TAB-1 TEXT -->


                                    <!-- TAB-1 IMAGE -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid" src="@/assets/images/tpe-virtuelle.png" width="500" alt="content-image">
                                        </div>
                                    </div>


                                </div>
                            </div>	<!-- END TAB-1 CONTENT -->

                        </div>	<!-- END TABS CONTENT -->


                    </div>
                </div>     <!-- End row -->
            </div>     <!-- End container -->
        </section>
        <!-- FIN QR Code APAYM-->

        <!-- Le TPE APAYM -->
        <section id="content-6" class="bg-scroll reduc_mob pro_part wide-60 content-section sct_tuto division">
            <div class="container">
                <div class="row d-flex align-items-center">

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-6 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="500">
                        <div class="content-img">
                            <img class="img-fluid" src="@/assets/images/tpe.webp" width="470" alt="content-image">
                        </div>
                    </div>


                    <!-- CONTENT TEXT -->
                    <div class="col-md-6">			 				
                        <div class="content-txt ind-45">


                            <!-- CONTENT BOX #1 -->
                            <div class="cbox-1 box-icon-sm green-icon animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="300">

                                <!-- Icon -->
                                
                               
                                <!-- Text -->
                                <div >

                                    <h2 class="h2-xs " >Le TPE APAYM</h2>

                                    <!-- Title -->
                                    

                                    <p>Le TPE APAYM en partenariat avec Orabank est un terminal de paiement électronique de dernière génération intégralement tactile. Il résiste aux tentatives de 
                                        fraude <strong>( Certification PCI PTS 3.0, homologation EMV niveau 1 et 2.)</strong> et réponds à toutes les normes de sécurité actuelles.
                                        </p>

                                    <p>Les transactions sont plus rapides qu'avec un TPE classique grâce à sa double connectivité 3G et WIFI</p>

                                    <!-- Text -->	
                                    <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                        <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                        <p><strong>Sans engagement :</strong> Pas de frais de gestion mensuel, vous ne payez qu'à l'utilisation</p>							
                                    </div>

                                    <!-- Text -->	
                                    <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                        <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                        <p><strong>Simple :</strong> Sans ouverture de compte bancaire</p>							
                                    </div>
                                        
                                    <!-- Text -->	
                                    <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                        <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                        <p><strong>Multi paiement :</strong> Accepte tous les moyens de paiement (cartes bancaires avec ou sans contact, Mobile Money, Google Pay, Apple Pay)</p>							
                                    </div>

                                     <!-- Text -->	
                                     <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                        <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                        <p><strong>Rapide  :</strong> Compensation immédiate des fonds</p>							
                                    </div>

                                    <!-- Text -->	
                                    <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                        <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                        <p><strong>Suivi  :</strong> Traçabilité des paiements depuis vos accès web</p>							
                                    </div>

                                          

                                            <p class="">
                                            <!-- Button -->						
                                            <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange">Créer un compte Pro</a>                    
                                            </p>

                                </div>

                            </div>
                        
                            


                        </div>
                    </div>	<!-- END CONTENT TEXT -->


                    


                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->	
        </section>
        <!-- FIN Le TPE APAYM -->


        <section id="download-2" class="wide-70 download-section">
            <div class="bg-scroll bg-inner division">
                <div class="container white-color">
                    <div class="row d-flex align-items-center">


                        <!-- DOWNLOAD TXT -->	
                        <div class="col-md-7 col-lg-7">
                            <div class="download-txt ind-45">

                            
                                <!-- Title -->
                                <h2 class="h2-xs animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="300">
                                    Multipliez vos revenus plus rapidement avec APAYM
                                </h2>

                                <!-- Text -->
                                <p class="p-lg animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="400">
                                    Les portes du monde entier s'ouvrent à vous. Vos transactions sont garanties dans le réseau mondial Visa, en toute sécurité.
                                </p>

                                <!-- HERO STORE BADGES -->													
                                <div class="stores-badge animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="500">
                                                                                                       
                                    <!-- Google Play -->	
                                    <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" target="_blank" class="store">
                                        <img class="googleplay-white badge_sect" src="@/assets/images/store_badges/googleplay-tra-white.png"  width="140" height="42" alt="googleplay-logo">
                                    </a>

                                    <!-- AppStore -->	
                                    <a href="https://apps.apple.com/app/id1211381693" target="_blank" class="store">
                                        <img class="appstore-white badge_sect" src="@/assets/images/store_badges/appstore-tra-white.png" width="140" height="42" alt="appstore-logo">
                                    </a>

                                    <!-- Google appgallery -->	
                                    <a href="https://appgallery.huawei.com/app/C104470711" target="_blank" class="store">
                                        <img class="googleplay-white badge_sect" src="@/assets/images/appgallery-badge.webp" width="140" height="42" alt="googleplay-logo">
                                    </a>

                                    
                                                    
                                </div>


                            </div>	
                        </div>	<!--END DOWNLOAD TXT -->				
                                
                                                    
                        <!-- DOWNLOAD IMAGE -->
                        <div class="col-md-5 col-lg-4 offset-lg-1 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="500">	
                            <div class="download-2-img text-center ind-15">
                                <img class="img-fluid" src="@/assets/images/phone-app-pro.webp" alt="Image APAYM">
                            </div>
                        </div>


                    </div>	   <!-- End row -->		
                </div>	   <!-- End container -->	
            </div>		<!-- End Inner Background -->
        </section>

        <section id="content-6" class="bg-scroll reduc_mob pro_part wide-60 content-section sct_tuto division">
            <div class="container">
                <div class="row d-flex align-items-center">

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-6 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="500">
                        <div class="content-img">
                            <img class="img-fluid" src="@/assets/images/stat-fiances.bf1b68e1.webp" width="400" alt="content-image">
                        </div>
                    </div>


                    <!-- CONTENT TEXT -->
                    <div class="col-md-6">			 				
                        <div class="content-txt ind-45">


                            <!-- CONTENT BOX #1 -->
                            <div class="cbox-1 box-icon-sm green-icon animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="300">

                                <!-- Icon -->
                                
                                <span class=""><img class="img-fluid" src="@/assets/images/icone-stat.webp" width="70" alt="content-image"></span>
                                <!-- Text -->
                                <div class="cbox-1-txt">

                                    <!-- Title -->
                                    <h5 class="h5-md">Contrôler vos flux financiers</h5>

                                    <p class="grey-color">Garder le contrôle sur votre Business. Contrôler instantanément vos ventes et toutes vos transactions 
                                        via l’application et gérer les performances de votre entreprise.
                                    </p>

                                </div>

                            </div>
                        
                            <!-- CONTENT BOX #3 -->
                            <div class="cbox-1 box-icon-sm green-icon animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="500">

                                <!-- Icon -->
                                <span class=""><img class="img-fluid" src="@/assets/images/qr-icone.webp" width="70" alt="content-image"></span>

                                <!-- Text -->
                                <div class="cbox-1-txt">

                                    <!-- Title -->
                                    <h5 class="h5-md">Comment le client effectue un paiement chez un commerçant via QR Code ?</h5>

                                    <!-- Text -->
                                    <p class="grey-color">Après avoir passé commande, le client scanne le QR Code à la caisse du commerçant. L'étape suivante pour le 
                                        client sera de renseigner le montant qu’il doit régler et ensuite approuver la transaction.
                                    </p>
                                    <p class="grey-color">Vos clients ont seulement besoin de l’appli APAYM sur leur smartphone. Vous également en tant que marchand, vous pouvez utiliser
                                        un smartphone et suivre toutes les transactions en temps réel sur le portail marchand.
                                    </p>

                                    <p class="grey-color">Le marchand entre dans l’application APAYM. Dans l’interface, il clique sur la section APAYM Pro et envoie le lien par whatsapp, sms, mail, hangout…</p>

                                </div>

                            </div>


                        </div>
                    </div>	<!-- END CONTENT TEXT -->


                    


                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->	
        </section>

        <section id="content-8" class="wide-60 reduc_mob content-section division sct_tuto  grey_bck_section">
            <div class="container">	


                <!-- SECTION TITLE 	-->	
                <div class="row">	
                    <div class="col-lg-10 offset-lg-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg"> Comment ouvrir un compte APAYM Pro ? </h2>

                        <!-- Text -->
                        <p>Avec APAYM Pro, vous recevez vos paiements et compensation instantanément.</p>
                                
                    </div>	
                </div> 	 <!-- END SECTION TITLE -->	


                <div class="row">
                    <div class="col-md-12">
                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid ltp1" src="@/assets/images/rapide_004bba31.webp" width="500" alt="content-image">
                                        </div>
                    


                        <!-- TABS CONTENT -->
                        <div class="tab-content" id="pills-tabContent">


                            <!-- TAB-1 CONTENT -->
                            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab1-list">
                                <div class="row d-flex align-items-center">


                                    <!-- TAB-1 TEXT -->
                                    <div class="col-md-6">
                                        <div class="content-txt ind-45">                             
                    
                                            <!-- Title -->	
                                            <h5 class="h5-md animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="500">
                                                La création d'un compte Marchand APAYM Pro :
                                            </h5>
                                                            
                                            <!-- Text -->	
                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Renseignez les informations de votre profil : identifiant du gérant, adresse email, numéro de téléphone, documents de l'entreprise 
                                                via notre lien de souscription : <a href="https://apaym.com/pro/souscription" target="_blank" class="link">https://apaym.com/pro/souscription</a></p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Vérification des documents fournis</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Activation du compte entreprise par notre back office en moins de 24h.</p>							
                                            </div>

                                            <!-- Title -->	
                                            <h5 class="h5-md animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="500">
                                                Documents et pièces à fournir
                                            </h5>

                                            <!-- Title -->	
                                            <br><p><strong>Entreprenants</strong></p>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Copie CNI/ Passeport ou Carte de séjour</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Numéro de patente</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Numéro de téléphone</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Adresse mail</p>							
                                            </div>

                                            <!-- Title -->	
                                            <br><p><strong>Entreprises</strong></p>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Copie CNI/ Passeport ou Carte consulaire du gérant</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Numéro de téléphone</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Registre de commerce, DFE</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Adresse mail</p>							
                                            </div>

                                            <!-- Title -->	
                                            <br><p><strong>ONG / Association</strong></p>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Copie CNI/ Passeport ou Carte consulaire du Président</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Numéro de téléphone</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Récépissé d’immatriculation</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Adresse mail</p>							
                                            </div>

                                            <p class="">
                                            <!-- Button -->						
                                            <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange">Créer un compte Pro</a>                    
                                            </p>


                                            </div>	
                                            

                                    </div>	<!-- END TAB-1 TEXT -->


                                    <!-- TAB-1 IMAGE -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid ltp2" src="@/assets/images/rapide_004bba31.webp" width="500" alt="content-image">
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>	<!-- END TAB-1 CONTENT -->

                        </div>	<!-- END TABS CONTENT -->


                    </div>	
                </div>     <!-- End row -->	
            </div>     <!-- End container -->	
        </section>

        <section id="content-8" class="wide-60 content-section division sct_tuto safety">
            <div class="container">	


                <!-- SECTION TITLE 	-->	
                <div class="row">	
                    <div class="col-lg-10 offset-lg-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">Protégez votre entreprise contre la fraude</h2>	

                        <!-- Text -->
                        <p>La protection de votre business est primordiale
                        </p>
                                
                    </div>	
                </div> 	 <!-- END SECTION TITLE -->	


                <div class="row">
                    <div class="col-md-12">
                    


                        <!-- TABS CONTENT -->
                        <div class="tab-content" id="pills-tabContent">


                            <!-- TAB-1 CONTENT -->
                            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab1-list">
                                <div class="row d-flex align-items-center">


                                    <!-- TAB-1 TEXT -->
                                    <div class="col-md-6">
                                        <div class="content-txt ind-45">  
                                            
                                            <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid ltp1" src="@/assets/images/security.webp" width="450" alt="content-image">
                                        </div>
                                            
                                            <!-- Text -->
                                            <p>Avec APAYM Pro, la protection de votre business est primordiale. Tout a été mis en place pour que vous puissiez
                                                bénéficier des meilleures normes de protection en matière de paiement en ligne. Nous sommes certifiés PCI DSS
                                                ( Normes de sécurité des données pour l’industrie des cartes de paiement).</p>
                    
                                            <!-- Title -->	
                                            <h5 class="h5-md animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="500">
                                                Des méthodes strictes pour vérifier l'identité de tous types de clients :
                                            </h5>
                                                            
                                            <!-- Text -->	
                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Protection contre la rétro-facturation</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Contrôles d’identité par une technologie permettant de vérifier l’identité et de l’âge en temps réel</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Fonds indemnisés à 100 %</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Vérification des transactions incluant des contrôles de rapidité, une vérification du code de sécurité, une surveillance des transactions en temps réel</p>							
                                            </div>                                
                                            
                                            <p class="" data-v-56bd18ea=""><!-- Button --><a href="https://apaym.com/pro/souscription" class="btn btn-lightorange" data-v-56bd18ea="">Créer un compte Pro</a></p>

                                        </div>	
                                    </div>	<!-- END TAB-1 TEXT -->


                                    <!-- TAB-1 IMAGE -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid ltp2" src="@/assets/images/security.webp" width="450" alt="content-image">
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>	<!-- END TAB-1 CONTENT -->

                        </div>	<!-- END TABS CONTENT -->


                    </div>	
                </div>     <!-- End row -->	
            </div>     <!-- End container -->	
        </section>

        <section id="download-4" class="bg-fixed p-top-100 contact-bck download-section division grey_bck_section">
            <div class="container">
                <div class="row">

                                
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Qu'est ce que vous attendez ?</h2>

                            <!-- Text -->
                            <p class="p-lg">Ne perdez plus de temps à vous soucier de vos paiements en ligne ! Téléchargez dès maintenant l'application APAYM et simplifiez votre vie en un instant.
                            </p>

                            <!-- HERO STORE BADGES -->													
                            <div class="stores-badge">

                                 <!-- Google Play -->
                                 <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" class="store">
                                    <img class="appstore-original badge_sect" src="@/assets/images/play_store_badge.webp" width="150" alt="appstore-logo">
                                </a> 

                               <!-- AppStore -->
                                <a href="https://apps.apple.com/app/id1211381693" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-store-bage.webp" width="150" alt="googleplay-logo">
                                </a>                                                                            
                                
                                <!-- App Gallery -->
                                <a href="https://appgallery.huawei.com/app/C104470711" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-gallery-badge.webp" width="150" alt="googleplay-logo">
                                </a>

                            </div>


                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->


                    <!-- DOWNLOAD IMAGE -->
                    <div class="col-md-12">	
                        <div class="download-img text-center">
                            <img class="img-fluid" src="@/assets/images/phones_app.webp" alt="Image APAYM">
                        </div>
                    </div>

                    
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'apaym_pro',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } 
}


</script>

<style scoped>
.wide-70 {
    padding-top: 0px !important;
    padding-bottom: 70px;
}
.badge_sect{
    max-width: 130px;
}
.ltp1{
    display: none;
}
@media screen and (max-width: 767px) {
    .safety[data-v-56bd18ea] {
    padding-top: 30px !important;
}
.reduc_mob[data-v-56bd18ea] {
    padding-top: 30px !important;
}
    .division.p-top-100 {
        padding-top: 30px;
    }
 
    .wide-60 {
    padding-top: 120px !important;
    padding-bottom: 0px !important;
}
    .ltp1{
    display: block !important;
}
.ltp2{
    display: none !important;
}
    .badge_sect{
    max-width: 108px !important;
    }
    #content-8 .section-title {
    margin-bottom: 10px !important;
    }
   
}
.contact-bck {
    background-image: url(@/assets/images/tra-waves-contact.png)!important;
    background-position: bottom center;
}
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;   
}
.safety {
    background: url(@/assets/images/safety.webp) no-repeat;
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}
.sct_tuto{
    padding-top: 90px !important;
}
#content-8 .section-title {
    margin-bottom: 70px;
}
.link{
    color: #261b64;
    font-weight: bold;
}
.link:hover{
   text-decoration: underline;
    
}
</style>

